import API from './axios';

export const fetchVerificacionesStock = async (params) => (await API.get('/verificaciones-stock', { params })).data;
export const resolverVerificacionStock = async (id, data) => (await API.patch(`/verificaciones-stock/${id}`, data)).data;
